import { cn } from '@workspace/ui/lib/utils';
import { type MouseEvent } from 'react';

interface SelectItemProps {
  value: string;
  label?: string;
  onClick?: (e: MouseEvent) => unknown;
}

export function SelectItem({ value, label, onClick }: SelectItemProps) {
  return (
    <div
      onClick={onClick}
      className={cn(
        `px-2 py-1.5 text-sm text-[#101010] tracking-[-0.1px] rounded-lg cursor-pointer hover:bg-[#0000000D] [&:not(:first-of-type)]:mt-2`,
        value.includes('font-') && value,
      )}
    >
      {label || value}
    </div>
  );
}
